var _defs, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _polygon2, _polygon3, _path34, _path35, _path36, _path37, _path38, _path39, _rect2, _rect3, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _polygon4, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _polygon5, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _polygon6, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _polygon7, _polygon8, _polygon9, _path121, _path122, _path123, _path124, _path125, _path126, _polygon10, _path127, _path128;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCareerBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebf3fa;}.cls-2{fill:#d5e5fb;}.cls-3{fill:#b7d3f3;}.cls-4{fill:#d2e3fc;}.cls-5{fill:#c5dcf8;}.cls-6{fill:#ffb27d;}.cls-7{fill:#1c468a;}.cls-8{fill:#163560;}.cls-9{fill:#b5453c;}.cls-10{fill:#ed975d;}.cls-11{fill:#fff;}.cls-12{fill:#ed7d2b;}.cls-13{fill:#f99746;}.cls-14{fill:#f9ddbf;}.cls-15{fill:#ed893e;}.cls-16{fill:#95c0f4;}.cls-17{fill:#78acea;}.cls-18{fill:#2e3552;}.cls-19{fill:#aec3ff;}.cls-20{fill:#a02e2e;}.cls-21{fill:#bc3f3f;}.cls-22{fill:#9db0f4;}.cls-23{fill:#233862;}.cls-24{fill:#2b478b;}.cls-25{fill:#e2915a;}.cls-26{fill:#2a4e96;}.cls-27{fill:#dceaff;}.cls-28{fill:#ed985f;}.cls-29{fill:#2c3a64;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.67,159.56s-41-43.7-12.25-84.46c10.73-15.21,38.12-23.75,63.3-16.82,14.87,4.09,37.42,3.49,59.46-32.59C175.24-23.51,300-1.14,275.65,85.06c-10.26,36.31,28,38,9,74.58Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.66,72,167.34,147l-47-40.14c-8.79,7.77-22.38,19.75-36,31.78-9.34,8.22-16.9,14.87-23,20.24l-42.68-.05c11.83-10.1,59.49-52.1,91.6-80.48L120,69.62l47.51,40.59,69.72-58.5Z",
    transform: "translate(0 0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.94 42.49 268.47 85.28 280.49 36.4 225.94 42.49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.49,132.65a79.34,79.34,0,0,0-.91-9.7c-.66-3.79-1.24-6-1.25-6-.09-.34-1.33-1.69-4.09-1.64s-2.51,1.81-2.51,1.81h0a.61.61,0,0,0,0,.15,84.74,84.74,0,0,1,2.46,21.23c0,.17,0,.46,0,.65,0,0,6.41.17,6.41,0A32.54,32.54,0,0,0,86.49,132.65Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.29,138.45c0,.17-.08.3-.19.3h0c-.11,0-.2-.13-.2-.3H81.41c0,.17-.09.3-.19.3h0c-.1,0-.19-.14-.19-.3a84.82,84.82,0,0,0-.45-9.41,74,74,0,0,0-2.1-11.76.61.61,0,0,1,0-.15s-.26-1.77,2.5-1.81,4,1.3,4.09,1.64c0,0,.34,1.25.79,3.47.14.73.3,1.57.46,2.52a79.34,79.34,0,0,1,.91,9.7A24.23,24.23,0,0,1,87.29,138.45Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.62,138.75h21.52s-.5-2-13-1.73C80.35,137.24,80.62,138.75,80.62,138.75Z",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.86,160c2.5-12.67,1.86-20.44,1.85-20.54s.36-.37.55-.38,1.06-.06,1.16.11A56.28,56.28,0,0,1,79.33,160Z",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99,160c-2.5-12.67-1.85-20.44-1.85-20.54s-.35-.37-.55-.38-1-.06-1.15.11A56.39,56.39,0,0,0,98.49,160Z",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.94,160c-2.49-12.67-1.85-20.44-1.85-20.54s-.35-.37-.54-.38-1.06-.06-1.16.11A56.28,56.28,0,0,0,102.48,160Z",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.87,160c2.5-12.67,1.86-20.44,1.85-20.54s.36-.37.55-.38,1.06-.06,1.16.11A56.28,56.28,0,0,1,83.34,160Z",
    transform: "translate(0 0)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 80.19,
    y: 138.23,
    width: 22.41,
    height: 1.17,
    rx: 0.59
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.4,119.91l7.15-1.55.42,1s-7.89,4.71-8.63,4.48S101.4,119.91,101.4,119.91Z",
    transform: "translate(0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.89,152.36a.63.63,0,0,0-.11.68h0a4.11,4.11,0,0,0,1.34,1.47l.21.18,0,.05,0,0c.59.54.37.67,1.43,1.77,1.2,1.25,2,1.27,2.26,1.16s-.2-.76-.65-1.51l-.07-.11-.18-.3c-.52-.9-.39-1.32-.26-2.66.1-1.09,1.69-6.08,1.69-6.08l-2.31-.4s-.69,4-1.46,4.59c-.41.32-.86.33-1.26.57l-.08,0A3.06,3.06,0,0,0,94.89,152.36Z",
    transform: "translate(0 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.89,152.36a.63.63,0,0,0-.11.68h0a4.88,4.88,0,0,0,1.34,1.47l.21.18,0,.05,0,0c.59.54.37.67,1.43,1.77,1.2,1.25,2,1.27,2.26,1.16s-.2-.76-.65-1.51a5.21,5.21,0,0,1-2.15-1.58c-.72-.93-1.2-2.12-1.7-2.81l-.08,0A3.06,3.06,0,0,0,94.89,152.36Z",
    transform: "translate(0 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.47,150.92c.14.71,1.16.59,2.29.31s.86.06,2.47-.12,2.1-.79,2.15-1-.75-.28-1.6-.38l-.33,0a7,7,0,0,1-2.54-1.26,10.17,10.17,0,0,1-2.07-2.46l-2.21.17s1.16,1.77,1.61,2.54a2.65,2.65,0,0,1,.21,1.51A3.22,3.22,0,0,0,113.47,150.92Z",
    transform: "translate(0 0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M115.76,151.23c1.13-.27.86.06,2.47-.12s2.1-.79,2.15-1-.75-.28-1.6-.38h0a4.53,4.53,0,0,1-2.31.72c-1.09,0-2.25-.28-3-.27a3.22,3.22,0,0,0,0,.76C113.61,151.63,114.63,151.51,115.76,151.23Z",
    transform: "translate(0 0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.55,118.36s.53-1.3,1.11-1.35,2.42-.34,2.55-.08a1.85,1.85,0,0,1-.39,1.56,14.44,14.44,0,0,1-2.85.9Z",
    transform: "translate(0 0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M105,136.74l-4.77,12.86a4.39,4.39,0,0,1-1.43-.13,6.24,6.24,0,0,1-1.39-.68s1.19-12.34,3.35-14.91S105,136.74,105,136.74Z",
    transform: "translate(0 0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.15,131.54s13.69-4.64,16.75-3.65,12.22,19.27,12.22,19.27a1.77,1.77,0,0,1-.77.49,7.26,7.26,0,0,1-1.8.19s-8.27-7.12-9.26-9.19-1.38-4.05-2.36-3.85-12.71,4.84-15.37,2.07a7.7,7.7,0,0,1-2-6.36Z",
    transform: "translate(0 0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94,98.81a3.29,3.29,0,0,0-1.8-.35.88.88,0,0,1,.38-.18,2.86,2.86,0,0,0-1,.26c-4.28-1.65-5,4.67-4.86,6.13s.1,3.16-2,4.48c-4.2,2.59-.66,7.11-.66,7.11s2,3.29,2,3.29c-.11-1.19,5.35-7.45,8.19-9.32a8.16,8.16,0,0,0,1-3,7.74,7.74,0,0,1-.58,2.68C96.93,107.72,95.53,99.7,94,98.81Z",
    transform: "translate(0 0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94,110.32a3.91,3.91,0,0,1-2.42.44A3.05,3.05,0,0,1,90,109.22c.41-.09.53-.66.52-3.13l.19,0,3.16.63s-.07,1-.07,1.94C93.75,109.49,93.8,110.24,94,110.32Z",
    transform: "translate(0 0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M93.82,106.76s-.07,1-.07,1.94c-1.77,0-2.71-1.67-3.09-2.57Z",
    transform: "translate(0 0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.33,105.79a9.56,9.56,0,0,1-1.15-2.73c-.15-.9.3-4.22,3.63-3.74a4.44,4.44,0,0,1,1.88.71c.73.49,1.77,1.55.6,4.45l-.3,1Z",
    transform: "translate(0 0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.42,107.65s-4.19.07-4.2-2.55-.54-4.37,2.13-4.52,3.2.84,3.41,1.72S95.51,107.56,94.42,107.65Z",
    transform: "translate(0 0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94.26,100.52s-1.15,3.06-2.91,3.52a3.47,3.47,0,0,1-2.52,0,5,5,0,0,0,1.63-3S93.4,99.05,94.26,100.52Z",
    transform: "translate(0 0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94,100.76A3.75,3.75,0,0,1,95,102.12c.21.66.3,2,.7,2,0,0,.87-2.09-.1-3.27S94,100.76,94,100.76Z",
    transform: "translate(0 0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.65,121.62c-.41-1.74,1-5.11,2.46-7.9a21,21,0,0,1,2.84-4.5c3.51,2.08,3.82.35,3.82.35h0s3.19.42,4.09,2c1.12,1.93,2.33,7.34,3.54,8.36a2.22,2.22,0,0,0,.09,1.57,3.09,3.09,0,0,0,.14.43,8,8,0,0,0,.6,1.24c-.61.37-1.79,1.08-2.66.57-1.33-.77-2.36-3.14-2.94-4.09h0c-1.26,7.18.46,8.82-.41,9.58s-2.24-.39-5.13.87a27.29,27.29,0,0,1-6.29,2.22c-.93.11-1.62,0-1.85-.68C82.29,129.78,85.44,124.93,84.65,121.62Z",
    transform: "translate(0 0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M93.48,106.06s.08.34.91.29c0,0,.69,0,.67-.41A2.26,2.26,0,0,0,93.48,106.06Z",
    transform: "translate(0 0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.94,131.61c.23.63.92.79,1.85.68,1.23-.53,6.52-2.59,6.46-4-.09-2.06-1-2.13-.36-4.68.53-2-4.37-5.84-5.15-6.67-1.46,2.79-1.5,2.92-1.09,4.66C85.44,124.93,82.29,129.78,82.94,131.61Z",
    transform: "translate(0 0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M82.34,124.17a7.8,7.8,0,0,1,2.56-2.37c-.14-.38,3.95-5.42,3.95-6.2s1.1-6.39,1.1-6.39-3.42.22-4.6,1.87C83.87,113.15,80.8,121.1,82.34,124.17Z",
    transform: "translate(0 0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.9,121.8l6.83,1.78-.65,1.16s-8.3-.06-8.74-.57S84.9,121.8,84.9,121.8Z",
    transform: "translate(0 0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.63,119.63c.58,1,1.61,3.32,2.94,4.09.87.51,2.05-.2,2.66-.57a8,8,0,0,1-.6-1.24c-.49.11-1.09.25-1.47.37C99.41,122.51,96.63,119.63,96.63,119.63Z",
    transform: "translate(0 0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.73,123.58a10.56,10.56,0,0,1,2.65-.46c.51.14,2.26,1.3,2,1.62s-1.79-.19-2.49-.1-1.26.45-1.77.37a5.8,5.8,0,0,1-1-.27Z",
    transform: "translate(0 0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.73,123.58a8.47,8.47,0,0,0,1.34-.84.09.09,0,0,1,.13,0c.08.13.16.37-.21.61A2,2,0,0,1,91.73,123.58Z",
    transform: "translate(0 0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M101.62,126.61h-10a.8.8,0,0,1,.8-.8h9.19Z",
    transform: "translate(0 0)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "101.59 115.69 117.05 115.69 113.34 126.61 97.79 126.61 101.59 115.69"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "117.27 115.69 113.57 126.61 98.02 126.61 101.82 115.69 117.27 115.69"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M108.94,121.05a1,1,0,0,1-.92.75.57.57,0,0,1-.58-.75,1,1,0,0,1,.92-.76A.58.58,0,0,1,108.94,121.05Z",
    transform: "translate(0 0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M117.27,115.69l-3.7,10.92h-10.3c6.82-2.34,8.64-9.46,8.94-10.92Z",
    transform: "translate(0 0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M72.42,160a.4.4,0,0,0,.39-.33l2-11,2.79-15.86.78-4.43-2-.06L76,130.86,73.57,149l-1.43,10.73A.28.28,0,0,0,72.42,160Z",
    transform: "translate(0 0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M76,130.86a2.88,2.88,0,0,1,1.56,1.92l.78-4.43-2-.06Z",
    transform: "translate(0 0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M121.87,160a.4.4,0,0,1-.4-.33l-1.94-11-2.79-15.86-.78-4.43,2-.06.34,2.57,2.42,18.1,1.44,10.73A.28.28,0,0,1,121.87,160Z",
    transform: "translate(0 0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M118.29,130.86a2.85,2.85,0,0,0-1.55,1.92l-.78-4.43,2-.06Z",
    transform: "translate(0 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 69.88,
    y: 126.6,
    width: 53.34,
    height: 3.48,
    rx: 1.74,
    transform: "translate(193.1 256.69) rotate(180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    y: 159.1,
    width: 300,
    height: 0.8,
    rx: 0.4
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M197.55,124.75s-1.32,1.64-.91,1.86,1.5.65,1.76.38a7.57,7.57,0,0,0,.34-2.2Z",
    transform: "translate(0 0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M197.6,124.78a1.88,1.88,0,0,0-.75.46c-.21.29-.68.72-.57.83s.79-.4.79-.4Z",
    transform: "translate(0 0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M202.54,102.81s-1.49,13.9-1.62,14.3c0,.08-.15.52-.31,1.16-.24.9-.57,2.2-.88,3.43-.47,1.87-.91,3.59-.91,3.59l-1.29-.43a80.14,80.14,0,0,1,.26-8.3c.34-1.56,1.4-11.11,1.94-12.4S202.54,102.81,202.54,102.81Z",
    transform: "translate(0 0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M199.44,136.14,191.33,134a2,2,0,0,1-1.42-2.43l.92-3.53a2,2,0,0,1,2.43-1.42l8.11,2.14a2,2,0,0,1,1.42,2.43l-.92,3.53A2,2,0,0,1,199.44,136.14Z",
    transform: "translate(0 0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M191.9,128.32l-.93,3.57a2,2,0,0,0,.48,1.88,2,2,0,0,0,.54.41h0a2.37,2.37,0,0,0,.4.15l8.11,2.13a2,2,0,0,0,2.43-1.42l.93-3.57a2,2,0,0,0-1.42-2.44l-2.79-.74.2-.76a.66.66,0,0,0-.47-.8l-.31-.08-1.69-.45-.43-.11a.61.61,0,0,0-.49.07.65.65,0,0,0-.31.4l-.2.76-1.61-.43-.2,0h0a2,2,0,0,0-1.73.58h0A1.93,1.93,0,0,0,191.9,128.32Zm7.35-.13-2.9-.76.2-.77a.24.24,0,0,1,.3-.17l.73.19,1.33.35.37.1a.09.09,0,0,1,.06,0,.24.24,0,0,1,.11.27Z",
    transform: "translate(0 0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.32,127s.36-.61.22-.82-.62.63-.62.63.34-.72.21-.84-.63.71-.63.71.32-.7.2-.73-.48.59-.48.59.19-.52,0-.5-.57.51-.57.51Z",
    transform: "translate(0 0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M200.61,118.27c-.24.9-.57,2.2-.88,3.43a13.43,13.43,0,0,1-.62-2.72c-.3-2.3.62-7.2.62-7.2Z",
    transform: "translate(0 0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.64,124.18a10.89,10.89,0,0,1,1.61,1.54,7.91,7.91,0,0,1,.61,2.15c0,.44-1.11-1-1.42-1.11s.33.59.25.74-.74-.34-1-.51-.44-1.25-.82-1.85S217.64,124.18,217.64,124.18Z",
    transform: "translate(0 0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M198.75,159.28h7.18c.51-.35-.14-3.77-.14-3.77s-2-.74-2.3.78-2.49,2-3.63,2.18A1.23,1.23,0,0,0,198.75,159.28Z",
    transform: "translate(0 0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M209.39,159.28h7.18c.51-.35-.14-3.77-.14-3.77s-2-.74-2.3.78-2.49,2-3.63,2.18A1.23,1.23,0,0,0,209.39,159.28Z",
    transform: "translate(0 0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M200.68,124.41s.32,4,.7,8.89c.52,6.59,1.91,22.92,1.91,22.92a3.5,3.5,0,0,0,2.93.36,63.92,63.92,0,0,0,2.23-12.07c0-.11,0-.21,0-.32.48-6.55,1.22-20.34,1.22-20.34Z",
    transform: "translate(0 0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M200.57,123s.43,5.43.81,10.29l7.07,11.21c0-.11,0-.21,0-.32.48-6.55,1.22-20.34,1.22-20.34Z",
    transform: "translate(0 0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M202.63,123s5.13,12.8,6.76,17.65c1.17,3.45,4.46,15.57,4.46,15.57a3.34,3.34,0,0,0,2.64-.41s1.22-12.38-1.25-15.87c-1.32-1.85-.33-19.25-5.65-19.4S202.63,123,202.63,123Z",
    transform: "translate(0 0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M212.4,124.18c-2.14,1.21-11.29,1.18-11.72.23-.94-2.12-1.18-12.89-.74-16.19,0,0,.24-5.07.74-4.85,3.38-1.56,8.86-.14,8.86-.14,1.47.43,1.35,3.81,1.76,8.56,0,.62.11,1.25.17,1.91.3,2.93.72,6.3,1.36,9.86C212.88,123.79,212.71,124,212.4,124.18Z",
    transform: "translate(0 0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207,102.66c-.06.9-1.24.8-2.66.48s-.9-1.17-.9-1.17,0-.64.11-1.42c0-.28.07-.58.12-.87l.09-.41c.18-.8,2.83,0,2.82.18C206.53,100,207,101.94,207,102.66Z",
    transform: "translate(0 0)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "203.97 104.24 203.85 102.99 205.42 103.28 204.82 104.4 203.97 104.24"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M203.48,101.38l-.94,1.43a2.09,2.09,0,0,0,.81,1.52l1.29-1.19A2.33,2.33,0,0,1,203.48,101.38Z",
    transform: "translate(0 0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M204.64,103.14a3.41,3.41,0,0,0,.78,1.39s2-.54,2.48-1.57l-1-1.35S206.81,102.63,204.64,103.14Z",
    transform: "translate(0 0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M206.6,99.91a4.88,4.88,0,0,1-3,.64c0-.28.07-.58.12-.87l.64-.13Z",
    transform: "translate(0 0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.41,98.94c-.62,1.72-2.9,1.28-3.87,1a3.73,3.73,0,0,1-.44-.14c-.3-.13-.39-.66-.37-1.32a10.17,10.17,0,0,1,.87-3.61c.44-.67,1.19-1.35,3.39-.4S208.21,96.73,207.41,98.94Z",
    transform: "translate(0 0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M209.12,98.05c-.7.57-2.2,1.63-2.2,1.63a2.66,2.66,0,0,0,.37-.77.93.93,0,0,0,0-.26,1.46,1.46,0,0,1,.2-.79c.09-.15.13-.3,0-.41s-.51,0-.72.13a.44.44,0,0,1-.47,0h0c-.6-.38.06-1-.42-1.58s-2.58-.62-2.5-1c-.71-.4-.26-1.9-.25-2a7.38,7.38,0,0,0,2.31-.23,3.41,3.41,0,0,1,2.55.69.57.57,0,0,0-.06-.26.52.52,0,0,1,.15.34s0,0,0,0a.72.72,0,0,1,.33.08s-.09,0-.13,0l0,0C209.71,94.73,209.69,97.58,209.12,98.05Z",
    transform: "translate(0 0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M204.12,98.69s-.11.22-.68,0c0,0-.47-.15-.39-.4A1.55,1.55,0,0,1,204.12,98.69Z",
    transform: "translate(0 0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M204,104.24s-1.25,15.89-1.23,17.21a5,5,0,0,0,1.39,2.73,5.81,5.81,0,0,0,1.3-2.47c.22-1.27-.6-17.31-.6-17.31Z",
    transform: "translate(0 0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M209.54,103.23s2,.48,3.62,3.57,2.86,9.3,3.63,10.94,1.29,6.8,1.29,6.8l-1.21.6s-2.92-5.3-3.36-7c-.23-.94-3.8-8.47-3.8-8.47Z",
    transform: "translate(0 0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M212.4,124.18h0c-3.81-.55-2.71-13.2-2.41-13.25s1.39,2.26,1.39,2.26l.1.51c.3,2.93.72,6.3,1.36,9.86C212.88,123.79,212.71,124,212.4,124.18Z",
    transform: "translate(0 0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M260,151.81s1.58,1.45,1.27,2.48-1.74,1.72-1.93,3-1,1.95-1.67,1.95H254.3s-.51-.89.73-1.15,1.7-1.75,1.63-3.13a24.27,24.27,0,0,1,.11-3.21l2.63-.61Z",
    transform: "translate(0 0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M240.48,155.56s.28,3.31-.41,3.65l-8.92,0s0-1,1.43-1.26,3.95-1.07,4.38-2.94S240.48,155.56,240.48,155.56Z",
    transform: "translate(0 0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M233,108.88s.47,5.79,1,12.76c.76,9.45,1.66,21.07,1.75,23.28.15,3.82.77,9.93.77,9.93a4.92,4.92,0,0,0,4.41.84,98.62,98.62,0,0,0,3.38-18l0-.46c.7-9.4,1.78-29.19,1.78-29.19Z",
    transform: "translate(0 0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M233,108.88s.47,5.79,1,12.76l10.31,16.09,0-.46c.7-9.4,1.78-29.19,1.78-29.19Z",
    transform: "translate(0 0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M235.1,109.57s8.47,21,14.05,30.84S256.46,153,256.46,153s3.2-1.26,3.49-2.12c0,0-2.14-19-5.87-23.68A22.23,22.23,0,0,1,250.25,116a36,36,0,0,0-1.62-10.25Z",
    transform: "translate(0 0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.33,109.88a16.44,16.44,0,0,0-1.7,2.72,11.56,11.56,0,0,0-.06,3.22c.19.6,1.17-1.79,1.57-2.07s-.25.94-.09,1.13.92-.75,1.22-1.07.16-1.9.48-2.87S228.33,109.88,228.33,109.88Z",
    transform: "translate(0 0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M235.31,78.65s-2.14,20-2.33,20.53c0,.12-.21.76-.44,1.67-.34,1.29-.82,3.16-1.27,4.93-.68,2.68-1.41,5-1.41,5a1.89,1.89,0,0,1-1.11.14,1.12,1.12,0,0,1-.81-.5s.07-9.8.55-12,2-16,2.78-17.81S235.31,78.65,235.31,78.65Z",
    transform: "translate(0 0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M232.54,100.85c-.34,1.29-.82,3.16-1.27,4.93a19,19,0,0,1-.89-3.91c-.43-3.31.89-10.34.89-10.34Z",
    transform: "translate(0 0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M249.47,109.34c-3.07,1.73-16.22,1.7-16.83.33-1.36-3-1.7-18.51-1.06-23.25,0,0,.33-7.29,1.06-7,4.86-2.24,12.72-.21,12.72-.21,2.12.63,1.94,5.49,2.53,12.31.08.88.16,1.79.26,2.74.41,4.21,1,9,1.95,14.16C250.16,108.78,249.93,109.08,249.47,109.34Z",
    transform: "translate(0 0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.73,78.42c-.08,1.31-1.78,1.16-3.82.69s-1.3-1.67-1.3-1.67,0-.93.16-2c0-.4.11-.83.18-1.25l.12-.6c.27-1.14,4.08,0,4.05.27C241.05,74.66,241.65,77.4,241.73,78.42Z",
    transform: "translate(0 0)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "237.36 80.7 237.2 78.9 239.45 79.32 238.59 80.93 237.36 80.7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M236.66,76.59l-1.35,2.06a3,3,0,0,0,1.17,2.18l1.85-1.72A3.32,3.32,0,0,1,236.66,76.59Z",
    transform: "translate(0 0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M238.33,79.11a4.87,4.87,0,0,0,1.12,2s2.88-.78,3.56-2.26l-1.5-1.94S241.44,78.39,238.33,79.11Z",
    transform: "translate(0 0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M241.14,74.47a7,7,0,0,1-4.37.93c0-.4.11-.83.18-1.25.5-.12.92-.2.92-.2Z",
    transform: "translate(0 0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.31,73.08c-.9,2.47-4.17,1.84-5.56,1.45l-.64-.21c-.43-.19-.56-.95-.52-1.9a14.56,14.56,0,0,1,1.24-5.18c.64-1,1.71-1.94,4.88-.58S243.46,69.91,242.31,73.08Z",
    transform: "translate(0 0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M244.76,71.81c-1,.82-3.16,2.34-3.16,2.34a4.15,4.15,0,0,0,.54-1.11,1.26,1.26,0,0,0,0-.37,2,2,0,0,1,.29-1.14c.13-.21.18-.44,0-.59s-.73,0-1,.19a.62.62,0,0,1-.67,0h0c-.86-.54.09-1.48-.61-2.27s-3.7-.89-3.58-1.39c-1-.58-.38-2.72-.36-2.84a11.08,11.08,0,0,0,3.31-.33,4.93,4.93,0,0,1,3.66,1,.79.79,0,0,0-.08-.36.73.73,0,0,1,.22.48s0,0,0,0a.92.92,0,0,1,.47.11s-.13,0-.19,0a0,0,0,0,1,0,0C245.62,67,245.59,71.13,244.76,71.81Z",
    transform: "translate(0 0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M237.58,72.72s-.16.31-1,.06c0,0-.68-.22-.57-.58A2.31,2.31,0,0,1,237.58,72.72Z",
    transform: "translate(0 0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M237.36,80.7s-1.8,22.82-1.78,24.72,2,3.92,2,3.92a8.36,8.36,0,0,0,1.87-3.55c.31-1.82-.86-24.86-.86-24.86Z",
    transform: "translate(0 0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M249.47,109.34h0c-5.48-.79-3.91-19-3.48-19s2,3.25,2,3.25l.15.74c.41,4.21,1,9,1.95,14.16C250.16,108.78,249.93,109.08,249.47,109.34Z",
    transform: "translate(0 0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M265.56,122.87,254,126.25a2.86,2.86,0,0,1-3.54-2l-1.46-5a2.87,2.87,0,0,1,1.94-3.54l11.58-3.38a2.86,2.86,0,0,1,3.54,2l1.46,5A2.86,2.86,0,0,1,265.56,122.87Z",
    transform: "translate(0 0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M250.52,118.82l1.47,5.09a2.88,2.88,0,0,0,2,2,3.08,3.08,0,0,0,1,.1h0a3.26,3.26,0,0,0,.61-.11l11.56-3.37a2.89,2.89,0,0,0,1.95-3.56l-1.48-5.09a2.87,2.87,0,0,0-3.55-2l-4,1.16-.31-1.08a1,1,0,0,0-1.17-.65l-.44.13-2.42.71-.6.17a.91.91,0,0,0-.56.46.9.9,0,0,0-.08.72l.31,1.08-2.3.67-.27.1h0a2.88,2.88,0,0,0-1.72,2h0A2.83,2.83,0,0,0,250.52,118.82Zm9-5.6-4.13,1.21-.32-1.09a.37.37,0,0,1,.24-.44l1-.3,1.91-.56.51-.15h.11a.34.34,0,0,1,.33.25Z",
    transform: "translate(0 0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256,110s-.36,3,.31,3,2.32-.37,2.43-.89-1.26-2.94-1.26-2.94Z",
    transform: "translate(0 0)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.09,110a2.85,2.85,0,0,0-.56,1.15c0,.5-.29,1.39-.06,1.44s.66-1.1.66-1.1Z",
    transform: "translate(0 0)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M245.36,79.24s2.91.7,5.21,5.13,4.11,13.36,5.21,15.72,1.93,9.43,1.93,9.43a1.08,1.08,0,0,1-.76.48,3.56,3.56,0,0,1-.93.06s-4.32-7-4.94-9.44c-.34-1.35-5.47-12.16-5.47-12.16Z",
    transform: "translate(0 0)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "53.86 156.34 53.43 153.19 55.26 151.66 55.83 155.82 53.86 156.34"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.94,159.15H52.48a4.13,4.13,0,0,1,.21-2c.37-.83,1-1.34,1-2a2.24,2.24,0,0,0,2.13.65,8.53,8.53,0,0,0,1.3,1.69C57.62,157.86,59.79,157.73,59.94,159.15Z",
    transform: "translate(0 0)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M58.44,113.85c-.49,3.93-.89,7.64-1.21,11.1a265.05,265.05,0,0,0-1.4,29.69s-.12.34-1.2.34a5.53,5.53,0,0,1-1.2-.13s-3.89-12-3.59-18.88a11,11,0,0,1,.3-2.22c.94-3.5-3.45-16.9,1.32-21.89S58.67,112,58.44,113.85Z",
    transform: "translate(0 0)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M58.44,113.85c-.49,3.93-.89,7.64-1.21,11.1l-7.39,11a11,11,0,0,1,.3-2.22c.94-3.5-3.45-16.9,1.32-21.89S58.67,112,58.44,113.85Z",
    transform: "translate(0 0)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.31,76.3s-.18-.9-.38-1.58a5,5,0,0,1,1-2.55c.43-.24,1.56,1.1,1.24,2.13-.17.53-.43,2.26-.43,2.26Z",
    transform: "translate(0 0)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.31,76.3s-.23-.52-.44-.6-.44-.94-.6-1.28c0,0,.15-.22.42.07s.51.68.51.68Z",
    transform: "translate(0 0)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.51,79.33a4.27,4.27,0,0,0-.16.42v-.13a5.09,5.09,0,0,0-1.67-2.15c-.49-.1-1.17,1.51-.57,2.4.32.46,1.08,2,1.08,2l1.25-.65s.08-.57.25-.71.15-1,.2-1.39C33.89,79.15,33.68,79,33.51,79.33Z",
    transform: "translate(0 0)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.35,155.4c-.1-1-.13-3.67-.13-3.67s2.7-.86,2.6-.27a19.22,19.22,0,0,0-.36,4.36l-1.09.66Z",
    transform: "translate(0 0)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M56.19,113.66s-10.42,28.63-12.47,41.05a2,2,0,0,1-1.36.22,1.53,1.53,0,0,1-1.28-.82s-1.88-14.89,1.86-20.06c2.57-3.55-1.11-19.14,4.88-20.39S56.19,113.66,56.19,113.66Z",
    transform: "translate(0 0)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.34,86.12h0s0,0,0,0c-.06-.25-.13-.5-.2-.75h0a17.1,17.1,0,0,0-.76-2.1c-.16-.36-.32-.7-.49-1l-.08-.13h0a3.06,3.06,0,0,0-1.19-1.3,3.58,3.58,0,0,0-2-.08.87.87,0,0,1,.37-.25,3,3,0,0,0-1,.43c-4.8-1.07-4.52,5.73-4.19,7.28s-1.22,2.29-3.4,3.87c-4.16,3-4.09,6.2-4.09,6.2l.12.06c.17-.42.53-1.2.9-1.36a16.41,16.41,0,0,0-.4,1.61c.63.35,1.51.89,2.46,1.51h0c1.28.81,2.68,1.75,3.81,2.52a2.48,2.48,0,0,1,0-1l.36,1.12,0,.14,1.58,1.08.08.06.13.09a6,6,0,0,1,1-2.72c.05-.09.1-.18.16-.27.22-.41.48-.84.75-1.29l.3-.48h0l.25-.39h0q.3-.48.63-1c.55-.82,1.14-1.64,1.73-2.39a20.43,20.43,0,0,1,2.37-2.67l.07-.15a4.91,4.91,0,0,0,.25-.82l.06-.26a11.72,11.72,0,0,0,.17-2,11.26,11.26,0,0,1,0,2.06c0,.11,0,.21-.05.3h0q-.06.32-.12.54a3.39,3.39,0,0,0,.46-.82A10.14,10.14,0,0,0,54.34,86.12Z",
    transform: "translate(0 0)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.44,93a4.19,4.19,0,0,1-2.5.85A3.42,3.42,0,0,1,49,92.48c.43-.16.47-.79.07-3.4h.2l3.46.17s.08,1.07.22,2.07C53.07,92.16,53.23,93,53.44,93Z",
    transform: "translate(0 0)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M52.72,89.26s.08,1.07.22,2.07c-1.88.22-3.13-1.35-3.68-2.24Z",
    transform: "translate(0 0)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.86,88.78a10.12,10.12,0,0,1-1.65-2.71c-.31-.93-.35-4.53,3.26-4.55a4.87,4.87,0,0,1,2.11.46c.84.41,2.12,1.36,1.33,4.63l-.16,1.08Z",
    transform: "translate(0 0)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M58.88,113.11a14.59,14.59,0,0,1-10.14,1.3l-4.65-.75c.08-.21.67-3.76.75-4,1-2.59,2.83-16.65,4.36-17.34a3.52,3.52,0,0,0,2.46.63c1.1-.1,1.47-.57,1.38-1.09,1.21.58,2.15,1.12,2.15,1.12C56.3,94.69,58.88,113.11,58.88,113.11Z",
    transform: "translate(0 0)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.48,90.11s-4.43.73-4.84-2-1.27-4.55,1.54-5.13,3.53.39,3.89,1.28S54.63,89.85,53.48,90.11Z",
    transform: "translate(0 0)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.2,82.57s-.74,3.43-2.53,4.19a3.71,3.71,0,0,1-2.68.38,5.35,5.35,0,0,0,1.26-3.39S51.05,81.15,52.2,82.57Z",
    transform: "translate(0 0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M51.94,82.88a4,4,0,0,1,1.34,1.26c.32.67.64,2.11,1,2,0,0,.59-2.35-.62-3.45S51.94,82.88,51.94,82.88Z",
    transform: "translate(0 0)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M65.74,76.37a2.6,2.6,0,0,0-.8-.25,2.26,2.26,0,0,0-.69.08S63,84,62.9,84.4s-5.36,6.37-6.78,6.34A6.43,6.43,0,0,0,53,91.9s3,6.34,3.13,7.53,1.71,21.23,1.71,21.23-.09.93,1.64.43a5.92,5.92,0,0,0,2.16-.91s-1.59-15.7-1.92-20.58a10,10,0,0,0-.3-1.82,1.83,1.83,0,0,1,.29-1.57c2.19-3,5.64-7.88,5.83-8.92C65.86,85.77,65.74,76.37,65.74,76.37Z",
    transform: "translate(0 0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M47.57,159.15H40.11a4.13,4.13,0,0,1,.21-2c.37-.83,1-1.34,1-2a2.26,2.26,0,0,0,2.14.65,7.83,7.83,0,0,0,1.3,1.69C45.24,157.86,47.42,157.73,47.57,159.15Z",
    transform: "translate(0 0)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M52.69,100c-.25-1.55-3.46-7.78-3.46-7.78a6.53,6.53,0,0,0-3.36-.12c-1.34.48-8.25-3.43-8.47-3.79s-3.93-7.28-3.93-7.28a.85.85,0,0,0-.8.08.91.91,0,0,0-.48.75S35,90.61,35.8,92c.46.81,4.31,3.64,7.3,5.76a1.88,1.88,0,0,1,.78,1.78c-.4,3-.51,4.66-1,9.77-.38,4.24-.53,12.45-.53,12.45A27.52,27.52,0,0,0,48,123a2.8,2.8,0,0,0,2.81-2.28S53,101.64,52.69,100Z",
    transform: "translate(0 0)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M52,88.74a2,2,0,0,0,1.18.22c.43-.07.53-.58.53-.58a1.66,1.66,0,0,0-.79,0A3.12,3.12,0,0,0,52,88.74Z",
    transform: "translate(0 0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.55,35.86s-2.07-3.7,0-4.45,3-.06,3.11.78a23,23,0,0,1-.79,4.16Z",
    transform: "translate(0 0)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M195.21,59.49a67.12,67.12,0,0,1-10.39,1.07,59.35,59.35,0,0,1-8-.36L175,60a35.89,35.89,0,0,1-9.5-2.58s5.59-11.73,10.11-11.28c5.3.53,14.28,5.29,15.17,4,1-1.51,1.85-14.43,1.85-14.43,2.35-1.62,3.75.08,3.75.08S201,58.44,195.21,59.49Z",
    transform: "translate(0 0)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M195.21,59.49a67.12,67.12,0,0,1-10.39,1.07,59.35,59.35,0,0,1-8-.36c-1.41-4.5-2.42-9.09.41-6.32C182.25,58.76,195.21,59.49,195.21,59.49Z",
    transform: "translate(0 0)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M165.1,154.26s-.4,4.67.58,5.15l12.59,0s0-1.46-2-1.78-5.58-1.51-6.18-4.16S165.1,154.26,165.1,154.26Z",
    transform: "translate(0 0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M174.34,97.78c-.06,3.06-.21,6.2-.49,9-1.36,13.42-1.84,29.64-2,32.77-.34,5.43-1.41,14.1-1.41,14.1s-2.12,2-6.25,1A142,142,0,0,1,160,129.09l0-.65c-.09-1.73-.19-3.72-.28-5.87-.63-14.35-1.31-35.68-1.31-35.68l15.79-3.72S174.5,90.18,174.34,97.78Z",
    transform: "translate(0 0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M174.34,97.78c-4,6.93-11.63,19.69-14.69,24.79-.63-14.35-1.31-35.68-1.31-35.68l15.79-3.72S174.5,90.18,174.34,97.78Z",
    transform: "translate(0 0)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.34,84.37s-2.57,3-2.8,3.87a17,17,0,0,0-.42,4.78c.22.91,1.93-2.54,2.55-2.91s-.47,1.37-.25,1.66,1.44-1,1.91-1.45.43-2.82,1-4.23S134.34,84.37,134.34,84.37Z",
    transform: "translate(0 0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M133.74,149s-2.24,2-1.8,3.51,2.46,2.42,2.73,4.2,1.36,2.76,2.35,2.76h4.69s.72-1.26-1-1.63-2.41-2.47-2.3-4.42a34.49,34.49,0,0,0-.16-4.53L134.5,148Z",
    transform: "translate(0 0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M171.64,87.21S156.85,118.94,149,132.86s-10.33,17.81-10.33,17.81-4.51-1.78-4.92-3c0,0,3-26.87,8.28-33.42,3-3.71,6.47-14.82,6.64-18.7s3.62-13.16,3.62-13.16Z",
    transform: "translate(0 0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M176,88.71a25.57,25.57,0,0,1-14.21,3.57c-3.65-.16-10.9-1.19-12.06-4.11-.28-.68-.08-1.55.33-2.88,1.07-3.46,3.56-10.06,2.81-24.68a24,24,0,0,1,.1-3.83c.78-7.2,4.9-11.47,8.88-12.86,9.7-3.4,12.93,1.31,12.93,1.31s4.29,3.4,4.94,10.51C181,70,176,88.71,176,88.71Z",
    transform: "translate(0 0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.66,43.1s4.45,2.72,9.28,1.95c0,0,.95-.25.48-1.37a13,13,0,0,0,.43-1.5,23.29,23.29,0,0,0,.55-2.44l-2.74-2.89-2.59-2.76A11.56,11.56,0,0,1,164.66,43.1Z",
    transform: "translate(0 0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M169.65,36.59a10.73,10.73,0,0,0,5.2,5.59c.42-1.55.7-3.17.7-3.17l-2.89-2.16Z",
    transform: "translate(0 0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.48,39.6s-8.5,1.06-9.09-4.17-2.1-8.63,3.3-9.53,6.68,1,7.31,2.68S180.67,39.18,178.48,39.6Z",
    transform: "translate(0 0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M166.7,25.05c-.07-.09-.24-.17-.64-.21a1.68,1.68,0,0,1,.75-.18,2,2,0,0,1,1.38-1.7,1.18,1.18,0,0,0-.61.83c1.14-1.08,3.5-1.81,10-1.05,8.5,1,5.48,6.36,4.35,7s-3.84-1.29-5.9-1.2-2.57,3.05-3.28,3.43-.41-.33-1.34-.79-1.08,1.1-.84,2.13-1.12,2.33-1.12,2.33l-1.26-1.47c-1.25-1.46-2.26-7.51-1.62-8.76C166.59,25.27,166.65,25.16,166.7,25.05Z",
    transform: "translate(0 0)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "192.65 33.41 178.23 33.53 178.13 31.36 192.51 30.24 192.65 33.41"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "203.54 33.77 187.84 34 187.66 30.04 203.31 28.82 203.54 33.77"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "214.13 34.08 200.88 34.1 200.64 28.75 213.83 27.55 214.13 34.08"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M214.32,35h0a.73.73,0,0,0,.7-.77l-.31-6.87a.74.74,0,0,0-.77-.7h0a.74.74,0,0,0-.71.77l.31,6.86A.75.75,0,0,0,214.32,35Z",
    transform: "translate(0 0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M178.18,34h0a.67.67,0,0,1-.69-.63l-.08-1.78a.67.67,0,0,1,.63-.69h0a.67.67,0,0,1,.69.63l.08,1.78A.66.66,0,0,1,178.18,34Z",
    transform: "translate(0 0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M150,85.29c1.07-3.46,3.56-10.06,2.81-24.68a24,24,0,0,1,.1-3.83h0C156.13,56.5,161,60,161,60S158,78.34,150,85.29Z",
    transform: "translate(0 0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M164.66,43.1s-8.19,1.41-12.46,6.64-11.13,12.59-12.76,15.18-6.13,20.14-6.13,20.14.3.56,1.54.89a2.92,2.92,0,0,0,2.06-.17s6-10.25,8.22-15.37c.93-2.13,17.08-10.55,23.15-9.68C170.67,61.07,164.66,43.1,164.66,43.1Z",
    transform: "translate(0 0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.56,29.62s1.77,1.08,2.82.62,1-.87,1-.87S193.16,28.48,192.56,29.62Z",
    transform: "translate(0 0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M172.6,48.83S169,71.57,143.52,78.19l-2.78,5.5,4.88.82s29-8.43,28.63-36.09Z",
    transform: "translate(0 0)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "172.04 45.2 170.87 45.31 170.87 47.02 172.6 48.83 174.25 48.42 174.25 46.05 173.07 45.2 172.04 45.2"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M167.43,40.67s-1.14.26-3.74,2.43c0,0,2.59,5.51,8.05,6.17a18,18,0,0,1,.31-4.07S167.72,43.64,167.43,40.67Z",
    transform: "translate(0 0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M172.05,45.2s2.66,1.42,2.86,3.63a4.45,4.45,0,0,0,.72-2.74,9,9,0,0,0-1.21-2.41S174.51,45,172.05,45.2Z",
    transform: "translate(0 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerBg);
export default __webpack_public_path__ + "static/media/career_bg.8f06b6a786f303fd40cd05d54473e218.svg";
export { ForwardRef as ReactComponent };